// FA — the product language. Translates en.js key for key.
//
// Every key here must exist in en.js (EN is the source catalogue) and every EN
// key must be translated here. tests/i18n.test.js asserts both directions.

export const fa = {
  // ── app ──────────────────────────────────────────────────────────────────
  'app.title': 'پارسینا — ماژول دندان‌پزشکی',

  // ── nav / chrome ─────────────────────────────────────────────────────────
  'nav.brand.name': 'پارسینا',
  'nav.brand.panel': 'دندان‌پزشکی',
  'nav.items.today': 'امروز',
  'nav.items.patients': 'بیماران',
  'nav.items.credits': 'اعتبار',
  'nav.items.profile': 'پروفایل',
  'nav.sidebar.collapse': 'بستن منو',
  'nav.sidebar.expand': 'باز کردن منو',
  'nav.sidebar.logout': 'خروج از حساب',
  'nav.sidebar.editProfile': 'پروفایل',
  'nav.clinic.label': 'کلینیک',
  // The AccountCard at the foot of the rail — the balance, and the menu that
  // holds every account-level destination. The unit is «پارسه» in BOTH locales.
  'nav.account.menuLabel': 'حساب کاربری',
  'nav.account.parsina': 'حساب پارسینا',
  'nav.account.parsinaHint': 'نام، رمز عبور، زبان',
  'nav.credits.label': 'اعتبار پارسهٔ شما',
  'nav.credits.topUp': 'شارژ اعتبار پارسه',
  'nav.clinicSwitch.label': 'رفتن به پنل کلینیک',
  // See the note on these keys in en.js.
  'nav.landmark.primary': 'منوی اصلی',
  'nav.landmark.content': 'محتوا',

  // ── common ───────────────────────────────────────────────────────────────
  'common.actions.cancel': 'انصراف',
  'common.actions.retry': 'تلاش مجدد',
  // The accessible name of every skeleton composite (DESIGN.md §"Loading & skeleton").
  'common.loading': 'در حال بارگذاری',
  'common.actions.save': 'ذخیره',
  'common.actions.saving': 'در حال ذخیره…',
  'common.actions.back': 'بازگشت',
  'common.actions.close': 'بستن',
  'common.actions.clearFilters': 'حذف فیلترها',
  'common.actions.join': 'پیوستن',
  // دکمه‌ای که در حال انجام کار است. «در حال ذخیره…» نیست: کنش اصلیِ
  // گفت‌وگوی نشست، تمدید توکن است و چیزی ذخیره نمی‌شود.
  'common.state.pleaseWait': 'لطفاً صبر کنید…',
  'common.labels.phone': 'تلفن',
  'common.labels.country': 'کشور',
  'common.labels.nationalId': 'کد ملی',
  'common.labels.fileNumber': 'شمارهٔ پرونده',
  'common.labels.none': '—',
  'common.gender.male': 'مرد',
  'common.gender.female': 'زن',
  'common.marital.single': 'مجرد',
  'common.marital.married': 'متأهل',
  'common.marital.divorced': 'مطلقه',
  'common.marital.widowed': 'بیوه',
  'common.units.years': '{{count}} سال',
  'common.units.years_one': '{{count}} سال',
  'common.units.minute': 'دقیقه',
  'common.units.second': 'ثانیه',
  // The unit word of CLINIC money in an Iranian clinic (IRR, shown as toman).
  // Not «پارسه» and not the credits screens' own `credits.toman`: those are
  // platform money and never follow a clinic's currency.
  'common.units.toman': 'تومان',
  'common.units.tomans': 'تومان',
  'common.punct.colon': ':',
  // Voice dictation (browser SpeechRecognition — see useSpeechToText.js).
  'common.voice.start': 'گفتن با صدا',
  'common.voice.stop': 'پایان ضبط',
  // بدون سه‌نقطه: بلافاصله بعدش زمان‌سنج می‌آید و «…۰۰:۱۲» بد خوانده می‌شود.
  'common.voice.listening': 'در حال شنیدن',
  'common.voice.priceTitle': '۵ پارسه برای هر دقیقه ضبط؛ به‌سمت بالا گرد می‌شود.',
  'common.voice.inlineTranscribing': 'در حال تبدیل…',
  'common.voice.error.denied': 'دسترسی به میکروفون داده نشد',
  'common.voice.error.no-mic': 'میکروفونی پیدا نشد',
  'common.voice.error.unsupported': 'این مرورگر ضبط صدا را پشتیبانی نمی‌کند',
  // getUserMedia فقط روی HTTPS وجود دارد. این همان چیزی است که موقع باز کردن
  // برنامه روی آی‌پد با آدرس IP شبکهٔ محلی دیده می‌شود.
  'common.voice.error.insecure': 'ضبط صدا فقط روی اتصال امن (HTTPS) کار می‌کند',
  'common.voice.error.credits': 'اعتبار پارسهٔ شما کافی نیست',
  'common.voice.error.auth': 'نشست شما معتبر نیست. دوباره وارد شوید',
  'common.voice.error.onboarding': 'ابتدا ثبت‌نام خود را کامل کنید',
  'common.voice.error.unavailable': 'سرویس تبدیل گفتار در دسترس نیست',
  'common.voice.error.timeout': 'تبدیل گفتار به متن بیش از حد طول کشید',
  'common.voice.error.generic': 'ضبط صدا ممکن نشد',

  // ── پوستهٔ موبایل ─────────────────────────────────────────────────────────
  // متنی که فقط به سطح ≤۷۶۸ پیکسل تعلق دارد. پیش‌فرض خودِ کیت برای این جاها
  // (MobileHeader.greeting و BottomSheet.closeLabel) رشتهٔ فارسی است، پس همه
  // باید صریح پاس داده شوند وگرنه در رابط انگلیسی فارسی نشت می‌کند.
  'mobile.greeting': 'خوش آمدید،',
  // بزرگ‌کنندهٔ فهرست. هرگز اسکرول بی‌نهایت: جای آدم در فهرست مهم است و روی
  // موبایل گم‌کردن آن بیشترین هزینه را دارد.
  'mobile.showMore': 'نمایش بیشتر',
  'mobile.close': 'بستن',

  // ── auth / boot ──────────────────────────────────────────────────────────
  'auth.checking': 'در حال ورود…',
  'auth.loading': 'در حال آماده‌سازی فضای کاری…',
  'auth.loopError': 'ورود مدام تکرار می‌شود. نشست را پاک کنید و دوباره تلاش کنید، یا با پشتیبانی تماس بگیرید.',
  'auth.loopTitle': 'ورود ناموفق بود',
  'auth.checkingHint': 'چند لحظه صبر کنید',
  'auth.stuck': 'هدایت نشدید؟',
  'auth.manualSignIn': 'اینجا کلیک کنید',
  'auth.retry': 'تلاش دوباره',
  'auth.signOut': 'خروج از حساب',
  'auth.bootFailed.title': 'شروع ممکن نشد',
  'auth.bootFailed.body': 'فضای کاری شما بارگذاری نشد. این خطا معمولاً موقتی است.',
  // پایان نشست — نگاه کنید به src/lib/session.js. عیناً همان متن پنل پزشک
  // (آنجا src/i18n/translations/fa/auth.json): دندان‌پزشکی که در هر دو پنل
  // کار می‌کند این گفت‌وگو را در هر دو می‌بیند، و دو نگارش برای یک رویداد
  // یعنی دو محصول متفاوت.
  'auth.session.expiringTitle': 'نشست شما رو به پایان است',
  'auth.session.expiringBody': 'برای ادامهٔ کار بدون قطع شدن، نشست را تمدید کنید.',
  'auth.session.staySignedIn': 'ادامهٔ کار',
  'auth.session.expiredTitle': 'نشست شما پایان یافته است',
  'auth.session.expiredBody': 'برای ادامه باید دوباره وارد شوید. صفحهٔ فعلی بسته نشده است؛ پس از ورود به همین صفحه بازمی‌گردید.',
  'auth.session.signInAgain': 'ورود مجدد',
  'auth.session.returnNotice': 'هر چیزی که پیش از این ذخیره کرده‌اید محفوظ است. موارد ذخیره‌نشدهٔ روی صفحه را پیش از ورود مجدد یادداشت کنید.',

  // ── errors ───────────────────────────────────────────────────────────────
  'errors.generic': 'خطایی رخ داد.',
  'errors.load.today': 'روز بارگذاری نشد.',
  'errors.load.patients': 'فهرست بیماران بارگذاری نشد.',
  'errors.load.patient': 'این پرونده بارگذاری نشد.',
  'errors.load.profile': 'پروفایل شما بارگذاری نشد.',
  'errors.load.drugs': 'جست‌وجوی دارو انجام نشد.',
  'errors.credits.title': 'اعتبار هوشمند کافی نیست',
  'errors.credits.body': 'بررسی تداخل دارویی نیازمند اعتبار است. از بخش «اعتبار» شارژ کنید — تجویز نسخه متوقف نمی‌شود.',

  // ── today (امروز) ─────────────────────────────────────────────────────────
  'today.title': 'امروز',
  'today.date.today': 'امروز',
  'today.date.prev': 'روز قبل',
  'today.date.next': 'روز بعد',
  // موبایل: با لمس برچسبِ روز، تقویم در یک شیت باز می‌شود تا هر تاریخی یک لمس
  // فاصله داشته باشد، نه چند بار زدنِ فلش.
  'today.date.pick': 'انتخاب تاریخ',
  'today.counts.total': 'نوبت‌ها',
  'today.counts.here': 'حاضر در کلینیک',
  'today.counts.scheduled': 'نوبت‌دار',
  'today.counts.completed': 'ویزیت‌شده',
  'today.counts.cancelled': 'لغو شده',
  // در موبایل ردیف آمار دقیقاً چهار کاشی است (امضای بصری طراحی)، پس KPI پنجمِ
  // شرطیِ دسکتاپ به این خط کم‌رنگ زیر ردیف تبدیل می‌شود.
  'today.counts.cancelledLine': '{{count}} لغو شده',
  // صف زنده واقعیتی دربارهٔ «همین حالا» است، پس فقط برای امروز وجود دارد. به‌جای
  // نمایش یک بلوک صفِ خالی در روزهای دیگر، صریح گفته می‌شود.
  'today.notice.liveQueue': 'صف زندهٔ اتاق انتظار فقط برای امروز نمایش داده می‌شود. روزهای دیگر فهرست نوبت‌ها را نشان می‌دهند.',
  // See the note on these keys in en.js. The Persian wording is the kit's own
  // `statusColors` labels verbatim — the desk and the dentist must not call the
  // same patient two different things.
  'today.status.scheduled': 'نوبت‌دار',
  'today.status.arrived': 'حاضر',
  'today.status.in_visit': 'در حال ویزیت',
  'today.status.completed': 'ویزیت‌شده',
  'today.status.cancelled': 'لغو شده',
  'today.status.no_show': 'عدم حضور',
  'today.blocks.queue': 'اتاق انتظار',
  'today.blocks.upcoming': 'پیش‌رو',
  'today.blocks.done': 'انجام‌شده',
  'today.next.title': 'بیمار بعدی',
  'today.next.at': 'ساعت {{time}}',
  'today.next.service': 'خدمت: {{name}}',
  'today.next.serviceVisit': 'ویزیت',
  'today.next.serviceMore': '+{{count}} مورد دیگر',
  'today.empty.title': 'برای این روز نوبتی ثبت نشده است',
  'today.empty.description': 'نوبت‌ها را پذیرش کلینیک ثبت می‌کند و به‌صورت خودکار اینجا نمایش داده می‌شوند.',
  'today.error.title': 'برنامهٔ روز در دسترس نیست',
  'today.queue.positionNext': 'نفر بعد',
  'today.queue.position': 'نفر {{position}}',
  'today.queue.waited': '{{count}} دقیقه انتظار',
  'today.queue.waitedHours': '{{hours}} ساعت انتظار',
  'today.queue.waitedHoursMinutes': '{{hours}} ساعت و {{minutes}} دقیقه انتظار',
  'today.queue.elapsed': '{{count}} دقیقه روی یونیت',
  'today.queue.elapsedHours': '{{hours}} ساعت روی یونیت',
  'today.queue.elapsedHoursMinutes': '{{hours}} ساعت و {{minutes}} دقیقه روی یونیت',
  'today.row.visit': 'جلسه',
  'today.row.visitFor': 'باز کردن جلسهٔ درمان {{name}}',
  'today.row.open': 'پرونده',
  // See the note on this key in en.js.
  'today.row.openFor': 'باز کردن پروندهٔ {{name}}',
  'today.row.walkIn': 'ثبت سریع',
  'today.row.unknownPatient': 'بیمار بدون نام',
  'today.readOnlyNote': 'ثبت، لغو و ترتیب صف بر عهدهٔ پذیرش کلینیک است. این پنل همان نوبت‌ها را می‌خواند.',

  // ── patients (بیماران) ────────────────────────────────────────────────────
  'patients.title': 'بیماران',
  'patients.subtitle': 'دفتر بیماران کلینیک — همان بیمارانی که پذیرش ثبت می‌کند',
  'patients.search.placeholder': 'نام، تلفن، کد ملی یا شمارهٔ پرونده',
  'patients.search.hint': 'برای جست‌وجو دست‌کم دو حرف بنویسید.',
  'patients.count': '{{count}} بیمار',
  'patients.columns.name': 'بیمار',
  'patients.columns.phone': 'تلفن',
  'patients.columns.fileNumber': 'شمارهٔ پرونده',
  'patients.columns.nationalId': 'کد ملی',
  'patients.empty.title': 'هنوز بیماری ثبت نشده است',
  'patients.empty.description': 'بیمارانی که در پذیرش کلینیک ثبت می‌شوند اینجا نمایش داده می‌شوند.',
  'patients.emptyFiltered.title': 'نتیجه‌ای یافت نشد',
  'patients.emptyFiltered.description': 'هیچ بیماری با این جست‌وجو مطابقت ندارد.',
  'patients.noClinic.title': 'هنوز عضو هیچ کلینیکی نیستید',
  'patients.noClinic.description': 'دفتر بیماران متعلق به کلینیک است. با کد دعوت کلینیک، از پروفایل خود به آن بپیوندید.',
  'patients.noClinic.action': 'رفتن به پروفایل',
  'patients.pendingClinic.title': 'عضویت شما هنوز تأیید نشده است',
  'patients.pendingClinic.description':
    'درخواست عضویت ثبت شده و تا زمانی که کلینیک آن را تأیید نکند، دفتر بیماران باز نمی‌شود. وضعیت را در پروفایل ببینید.',
  'patients.error.title': 'فهرست بیماران در دسترس نیست',

  // ── patient workspace ────────────────────────────────────────────────────
  'patient.tabs.summary': 'خلاصه',
  'patient.tabs.history': 'سوابق',
  // نوار بخش‌های چسبانِ پروندهٔ موبایل یک لندمارک است؛ نام آن را کیت به‌صورت
  // prop می‌گیرد و رشتهٔ فارسی را در خودش hardcode نمی‌کند.
  'patient.tabs.sectionsLabel': 'بخش‌های پرونده',
  'patient.actions.prescribe': 'نسخه',
  'patient.notFound.title': 'پرونده پیدا نشد',
  'patient.notFound.description': 'چنین بیماری وجود ندارد، یا برای شما قابل مشاهده نیست.',
  'patient.error.title': 'این پرونده در دسترس نیست',
  'patient.stats.age': 'سن',
  'patient.stats.allergies': 'حساسیت',
  'patient.stats.medications': 'دارو',
  'patient.summary.demographics': 'مشخصات',
  'patient.summary.allergies': 'حساسیت‌ها',
  'patient.summary.noAllergies': 'حساسیتی ثبت نشده است.',
  // See the note on these keys in en.js.
  'patient.severity.mild': 'خفیف',
  'patient.severity.moderate': 'متوسط',
  'patient.severity.severe': 'شدید',
  'patient.conditionStatus.active': 'فعال',
  'patient.conditionStatus.inactive': 'غیرفعال',
  'patient.conditionStatus.resolved': 'برطرف‌شده',
  'patient.conditionStatus.remission': 'در دورهٔ بهبود',
  'patient.photo.open': 'دیدن عکس {{name}} در اندازه بزرگ',
  'patient.photo.alt': 'عکس پروفایل {{name}}',
  'patient.summary.allergyWarning': 'حساسیت‌های ثبت‌شده — پیش از تجویز بررسی کنید.',
  'patient.fields.birthDate': 'تاریخ تولد',
  'patient.fields.gender': 'جنسیت',
  'patient.fields.maritalStatus': 'وضعیت تأهل',
  'patient.fields.bloodType': 'گروه خونی',
  'patient.fields.job': 'شغل',
  'patient.fields.insurance': 'بیمه',
  'patient.fields.height': 'قد',
  'patient.fields.createdAt': 'تاریخ ثبت',
  'patient.history.conditions': 'تشخیص‌ها',
  'patient.history.medications': 'داروها',
  'patient.history.noConditions': 'تشخیصی ثبت نشده است.',
  'patient.history.noMedications': 'دارویی ثبت نشده است.',
  'patient.history.prescribedOn': 'تجویز {{date}}',

  // ── prescription (نسخه) ──────────────────────────────────────────────────
  'prescription.title': 'نسخه',
  'prescription.subtitle': 'برای {{name}}',
  'prescription.search.label': 'افزودن دارو',
  'prescription.search.placeholder': 'جست‌وجو در فهرست داروها…',
  'prescription.search.searching': 'در حال جست‌وجو…',
  'prescription.search.empty': 'دارویی یافت نشد.',
  'prescription.search.hint': 'دست‌کم دو حرف بنویسید.',
  // See the note on this key in en.js.
  'prescription.search.results': '{{count}} دارو یافت شد.',
  'prescription.item.dose': 'دوز',
  'prescription.item.frequency': 'تواتر',
  'prescription.item.duration': 'مدت',
  'prescription.item.note': 'توضیح',
  'prescription.item.remove': 'حذف {{name}}',
  'prescription.empty.title': 'هنوز دارویی افزوده نشده است',
  'prescription.empty.description': 'از کادر بالا اولین دارو را جست‌وجو و اضافه کنید.',
  'prescription.save': 'ثبت نسخه',
  'prescription.saveConfirm': 'تأیید و ثبت',
  'prescription.saving': 'در حال ثبت…',
  'prescription.saved': 'نسخه ثبت شد.',
  'prescription.saveFailed': 'ثبت نسخه انجام نشد.',
  'prescription.savePartial': '{{saved}} دارو از {{total}} دارو ثبت شد.',
  'prescription.allergies.title': 'حساسیت‌های ثبت‌شده',
  'prescription.interactions.title': 'بررسی تداخل',
  'prescription.interactions.checking': 'در حال بررسی…',
  'prescription.interactions.none': 'تداخلی میان این داروها یافت نشد.',
  'prescription.interactions.needsTwo': 'برای بررسی تداخل، داروی دوم را اضافه کنید.',
  'prescription.interactions.unavailable': 'بررسی تداخل در حال حاضر در دسترس نیست. تجویز نسخه متوقف نمی‌شود.',
  'prescription.interactions.severity.high': 'زیاد',
  'prescription.interactions.severity.moderate': 'متوسط',
  'prescription.interactions.severity.low': 'کم',
  'prescription.interactions.type.interaction': 'تداخل',
  'prescription.interactions.type.contraindication': 'منع مصرف',
  'prescription.interactions.type.allergy': 'حساسیت',
  'prescription.interactions.type.black_box': 'هشدار جدی',
  'prescription.history.title': 'تجویزهای پیشین',
  'prescription.history.empty': 'تجویز پیشینی ثبت نشده است.',

  // ── profile ──────────────────────────────────────────────────────────────
  'profile.title': 'پروفایل',
  'profile.subtitle': 'هویت، کلینیک‌ها و شیفت‌های شما',
  'profile.sections.label': 'بخش‌های پروفایل',
  'profile.sections.identity': 'هویت',
  'profile.sections.clinics': 'کلینیک‌ها',
  'profile.sections.presence': 'شیفت‌ها',
  'profile.sections.appearance': 'ظاهر و زبان',
  'profile.fields.fullName': 'نام و نام خانوادگی',
  'profile.fields.medicalCode': 'کد نظام پزشکی',
  'profile.fields.specialty': 'تخصص',
  'profile.fields.bio': 'دربارهٔ شما',
  // Copy, not the stored value — see the note on this key in en.js.
  'profile.specialtyValue': 'دندان‌پزشکی',
  'profile.medicalCodeLocked': 'کد نظام پزشکی هنگام ثبت‌نام ثبت شده و قابل ویرایش نیست. برای اصلاح آن با پشتیبانی پارسینا تماس بگیرید.',
  'profile.specialtyLocked': 'این پنل برای دندان‌پزشکان است، بنابراین تخصص ثابت است. تغییر آن از جای دیگر، دسترسی حساب شما به این پنل را می‌بندد.',
  'profile.saved': 'پروفایل ذخیره شد.',
  'profile.noChanges': 'تغییری اعمال نشد.',
  'profile.saveFailed': 'ذخیرهٔ پروفایل انجام نشد.',
  'profile.duplicateCode': 'این کد نظام پزشکی قبلاً برای حساب دیگری ثبت شده است.',
  'profile.clinics.empty': 'هنوز عضو هیچ کلینیکی نیستید.',
  'profile.clinics.status.pending': 'در انتظار تأیید کلینیک',
  'profile.clinics.status.active': 'فعال',
  'profile.clinics.visitDuration': 'نوبت {{count}} دقیقه',
  // انتخابگر کلینیک فعال در سایدبارِ دسکتاپ است و زیر ۷۶۸ پیکسل سایدباری وجود
  // ندارد — پس روی موبایل اینجاست، وگرنه دندان‌پزشکِ چندکلینیکی برای همیشه در یک
  // اسکوپ حبس می‌شود بدون آنکه بتواند بگوید کدام.
  'profile.clinics.activeScope': 'کلینیک فعال',
  'profile.clinics.activeScopeHint': 'امروز و بیماران همین کلینیک را نشان می‌دهند.',
  'profile.clinics.joinTitle': 'پیوستن به کلینیک',
  'profile.clinics.joinHint': 'کد دعوت را از مدیر کلینیک بگیرید.',
  'profile.clinics.joinPlaceholder': 'کد دعوت',
  'profile.clinics.joined': 'به {{name}} پیوستید.',
  'profile.clinics.notFound': 'کلینیکی با این کد دعوت وجود ندارد.',
  'profile.clinics.joinFailed': 'پیوستن به کلینیک انجام نشد.',
  'profile.presence.empty': 'کلینیک هنوز شیفتی برای شما تعریف نکرده است.',
  'profile.presence.oneOff': 'تک‌روز',
  // See the note on this key in en.js.
  'profile.presence.inactive': 'غیرفعال',
  'profile.presence.readOnly': 'شیفت‌ها را کلینیک تعیین می‌کند؛ این پنل فقط آن‌ها را می‌خواند.',
  'profile.presence.days.0': 'دوشنبه',
  'profile.presence.days.1': 'سه‌شنبه',
  'profile.presence.days.2': 'چهارشنبه',
  'profile.presence.days.3': 'پنجشنبه',
  'profile.presence.days.4': 'جمعه',
  'profile.presence.days.5': 'شنبه',
  'profile.presence.days.6': 'یکشنبه',
  'profile.appearance.theme': 'رنگ تأکیدی',
  'profile.appearance.fontSize': 'اندازهٔ متن',
  'profile.appearance.language': 'زبان',
  'profile.appearance.saved': 'تنظیم ذخیره شد.',
  'profile.appearance.failed': 'تنظیم روی سرور ذخیره نشد.',
  'profile.theme.default': 'آبی پارسینا',
  'profile.theme.teal': 'فیروزه‌ای',
  'profile.theme.ocean': 'لاجوردی',
  'profile.theme.slate': 'خاکستری آبی',
  'profile.fontSize.small': 'کوچک',
  'profile.fontSize.medium': 'متوسط',
  'profile.fontSize.large': 'بزرگ',
  'profile.language.fa': 'فارسی',
  'profile.language.en': 'English',
  'profile.language.fr': 'Français',
  'profile.language.de': 'Deutsch',

  // ── onboarding ───────────────────────────────────────────────────────────
  'onboarding.title': 'ماژول دندان‌پزشکی پارسینا',
  'onboarding.subtitle.step1': 'یک‌بار ثبت‌نام کنید تا حساب شما شناسایی شود',
  'onboarding.subtitle.clinic': 'به کلینیکی که در آن کار می‌کنید متصل شوید',
  'onboarding.subtitle.done': 'آماده‌اید',
  'onboarding.progress.step1': 'ثبت‌نام',
  'onboarding.progress.clinic': 'کلینیک',
  'onboarding.progress.done': 'پایان',
  'onboarding.step1.fullName': 'نام و نام خانوادگی',
  'onboarding.step1.fullNamePlaceholder': 'دکتر مریم احمدی',
  'onboarding.step1.medicalCode': 'کد نظام پزشکی',
  'onboarding.step1.medicalCodePlaceholder': 'مثلاً ۱۲۳۴۵۶',
  'onboarding.step1.specialty': 'تخصص',
  'onboarding.step1.bio': 'دربارهٔ شما (اختیاری)',
  'onboarding.step1.submit': 'ادامه',
  'onboarding.step1.specialtyNote': 'این پنل ماژول دندان‌پزشکی است، بنابراین تخصص برای شما تعیین شده است.',
  'onboarding.clinic.choiceTitle': 'مطب یا کلینیک شما',
  'onboarding.clinic.choiceDescription': 'اگر مطب خودتان را دارید، همین‌جا ثبتش کنید. اگر در کلینیک دیگری کار می‌کنید، با کد دعوت به آن بپیوندید.',
  'onboarding.clinic.ownTitle': 'مطب خودم را ثبت می‌کنم',
  'onboarding.clinic.ownBody': 'برای مطب شخصی. شما مالک آن خواهید بود.',
  'onboarding.clinic.joinTitle': 'به کلینیک موجود می‌پیوندم',
  'onboarding.clinic.joinBody': 'با کد دعوتی که کلینیک به شما داده است.',
  'onboarding.clinic.back': 'بازگشت',
  'onboarding.clinic.ownName': 'نام مطب',
  'onboarding.clinic.ownNamePlaceholder': 'مطب دکتر احمدی',
  'onboarding.clinic.ownCity': 'شهر (اختیاری)',
  'onboarding.clinic.ownAddress': 'نشانی (اختیاری)',
  'onboarding.clinic.ownPhone': 'تلفن مطب (اختیاری)',
  'onboarding.clinic.create': 'ثبت مطب',
  'validation.clinicName': 'نام مطب را وارد کنید.',
  'onboarding.clinic.alreadyExists': 'برای این حساب از قبل مطبی ثبت شده است.',
  // The currency the practice keeps its books in. `{{currency}}` is a name
  // with its ISO code, e.g. «درهم امارات (AED)».
  'onboarding.clinic.currency': 'واحد پول مطب',
  'onboarding.clinic.currencyHint': 'تعرفه‌ها و طرح‌های درمان با همین واحد ثبت می‌شوند. تا پیش از ثبت نخستین مبلغ، از پنل کلینیک قابل تغییر است.',
  'onboarding.clinic.currencyIrr': 'تومان (IRR)',
  'onboarding.clinic.currencyMismatch': 'برای این حساب از قبل مطبی با واحد پول {{currency}} ثبت شده است. همان واحد را انتخاب کنید، یا آن را در پنل کلینیک تغییر دهید.',
  'onboarding.clinic.setupIncomplete': 'مطب ثبت شد، اما واحد پول آن در حسابداری تنظیم نشد. مطب را دوباره ثبت نکنید؛ برای تکمیل آن با پشتیبانی پارسینا تماس بگیرید.',
  'onboarding.clinic.title': 'به کلینیک خود بپیوندید',
  'onboarding.clinic.description': 'با کد دعوت کلینیک، نوبت‌ها و دفتر بیماران برای شما باز می‌شود. این کار را بعداً هم می‌توانید از پروفایل انجام دهید.',
  'onboarding.clinic.placeholder': 'کد دعوت',
  'onboarding.clinic.join': 'پیوستن',
  'onboarding.clinic.skip': 'بعداً',
  'onboarding.done.title': 'خوش آمدید',
  'onboarding.done.body': 'فضای کاری دندان‌پزشکی شما آماده است. در «امروز» نوبت‌هایی را می‌بینید که کلینیک برایتان ثبت می‌کند.',
  'onboarding.done.enter': 'ورود به پنل',

  // ── validation ───────────────────────────────────────────────────────────
  'validation.medicalCode': 'کد نظام پزشکی را وارد کنید.',
  'validation.fullName': 'نام و نام خانوادگی را وارد کنید.',
  'validation.invitationCode': 'کد دعوت را وارد کنید.',
  'validation.officePhone': 'تلفن مطب کامل نیست. آن را اصلاح کنید یا خالی بگذارید.',
  'validation.phone.tooShort': 'شمارهٔ {{country}} کوتاه است — نمونه: {{example}}',
  'validation.phone.tooLong': 'شمارهٔ {{country}} بلند است — نمونه: {{example}}',
  'validation.phone.invalid': 'شمارهٔ واردشده معتبر نیست.',

  // ── چارت دندان / odontogram ──────────────────────────────────────────────
  'patient.tabs.plan': 'پلن درمان',
  'patient.plan.empty.title': 'هنوز طرح درمانی برای این بیمار ثبت نشده',
  'patient.plan.empty.description': 'پلن درمان در جریان ویزیت ثبت می‌شود.',
  'patient.plan.noLines': 'این دوره هنوز ردیفی ندارد.',
  'patient.plan.doneTitle': 'درمان‌های انجام‌شده',
  'patient.plan.outstanding': '{{count}} اقدام انجام‌نشده — مجموع {{amount}}',
  'patient.tabs.chart': 'چارت دندان',
  'chart.tooth': 'دندان',
  'chart.universalShort': 'شمارهٔ آمریکایی',
  'chart.annotation.planned': 'در برنامه',
  'chart.annotation.treated': 'درمان‌شده',
  'chart.legend.planned': 'در برنامه',
  'chart.legend.treated': 'درمان‌شده',
  'chart.tooltip.treated': 'درمان‌های انجام‌شده',
  'chart.tooltip.andMore': 'و {{count}} مورد دیگر',
  'chart.tooltip.planned': 'در برنامه',
  'chart.wholeMouth.title': 'کل دهان',
  'chart.history.title': 'تاریخچهٔ دندان {{fdi}}',
  'chart.history.treatment': 'درمان',
  'chart.history.event': 'چارت',
  'chart.history.causedBy': 'از درمان بالا',
  'chart.history.empty': 'هنوز چیزی برای این دندان ثبت نشده است.',
  'chart.history.unavailable': 'تاریخچهٔ این دندان خوانده نشد.',
  'chart.history.session': 'جلسهٔ {{n}}',
  'chart.history.voided': 'ابطال‌شده — {{reason}}',
  'chart.notCharted': 'ثبت\u200cنشده',
  'chart.patientRight': 'راست بیمار',
  'chart.patientLeft': 'چپ بیمار',
  'chart.aria.odontogram': 'چارت دندان — برای ثبت، روی دندان یا سطح آن کلیک کنید',
  'chart.hint': 'برای ثبت روی یک سطح کلیک کنید، یا روی خود دندان برای وضعیت کلی.',
  // ── چارت، موبایل ─────────────────────────────────────────────────────────
  // chart.hint از کنشِ ماوس حرف می‌زند. روی صفحهٔ لمسی هر تاج حدود ۱۰ پیکسل و هر
  // سطح بسیار کمتر است — زیر کفِ ۴۴ پیکسل، و بدون شکستن قاب آناتومیک قابل
  // بزرگ‌کردن نیست. پس موبایل متن خودش و انتخابگر دندانِ ≥۴۴ پیکسلی خودش را دارد.
  'chart.mobile.settings': 'تنظیمات نمودار',
  'chart.mobile.pickTooth': 'انتخاب دندان',
  'chart.mobile.tapHint': 'روی دندان در نمودار بزنید، یا از فهرست پایین یکی را انتخاب کنید — سطوح در شیتی که باز می‌شود ثبت می‌شوند.',
  'chart.mobile.legend': 'راهنما',
  'chart.legend.bridge': 'بریج',
  'chart.legend.wholeToothCaries': 'پوسیدگی کل دندان',
  'chart.export.button': 'خروجی تصویر',
  'chart.export.error': 'خروجی تصویر ممکن نشد — مرورگر از آن پشتیبانی نمی\u200cکند.',
  'chart.material': 'جنس',
  'chart.isHistorical': 'کار قبلی (امروز انجام نشده)',
  'chart.showPrimary': 'نمایش دندان\u200cهای شیری',
  'chart.hidePrimary': 'پنهان\u200cکردن دندان\u200cهای شیری',
  'chart.showUniversal': 'نمایش شمارهٔ آمریکایی',
  'chart.hideUniversal': 'پنهان\u200cکردن شمارهٔ آمریکایی',
  'chart.error.title': 'چارت بارگذاری نشد',
  'chart.error.body': 'دریافت چارت دندان ممکن نشد. دوباره تلاش کنید.',
  'chart.summary.charted': 'ثبت\u200cشده',
  'chart.summary.decayed': 'پوسیده',
  'chart.summary.restored': 'ترمیم\u200cشده',
  'chart.summary.missing': 'کشیده\u200cشده',
  'chart.summary.dmft': 'شاخص DMFT',
  'chart.presence.title': 'وضعیت دندان',
  'chart.presence.present': 'موجود',
  'chart.presence.extracted': 'کشیده\u200cشده',
  'chart.presence.exfoliated': 'افتاده (شیری)',
  'chart.presence.congenitally_absent': 'فقدان مادرزادی',
  'chart.presence.unerupted': 'نروییده',
  'chart.presence.impacted': 'نهفته',
  'chart.surfaces.title': 'سطوح',
  'chart.surfaces.hint': 'یک سطح را انتخاب کنید، سپس وضعیت آن را',
  'chart.surfaces.setFor': 'وضعیت برای',
  'chart.surface.M': 'مزیال',
  'chart.surface.D': 'دیستال',
  'chart.surface.F': 'باکال/لبیال',
  'chart.surface.L': 'لینگوال/پالاتال',
  'chart.surface.O': 'اکلوزال',
  'chart.surface.I': 'اینسایزال',
  'chart.surfaceState.sound': 'سالم',
  'chart.surfaceState.caries': 'پوسیدگی',
  'chart.surfaceState.restoration': 'ترمیم',
  'chart.surfaceState.recurrent_caries': 'پوسیدگی ثانویه',
  'chart.surfaceState.temporary': 'ترمیم موقت',
  'chart.surfaceState.sealant': 'فیشورسیلانت',
  'chart.surfaceState.fractured': 'شکستگی',
  'chart.condition.title': 'کل دندان',
  'chart.condition.hint': 'مستقل از سطوح بالا',
  'chart.conditionName.sound': 'سالم',
  'chart.conditionName.caries': 'پوسیدگی',
  'chart.conditionName.root_canal': 'عصب\u200cکشی',
  'chart.conditionName.post_core': 'پست و کور',
  'chart.conditionName.crown': 'روکش',
  'chart.conditionName.veneer': 'ونیر / لمینت',
  'chart.conditionName.implant': 'ایمپلنت',
  'chart.conditionName.bridge_abutment': 'پایهٔ بریج',
  'chart.conditionName.bridge_pontic': 'پونتیک',
  'chart.conditionName.fracture': 'شکستگی',
  'chart.conditionName.attrition': 'سایش',
  'chart.conditionName.mobility': 'لقی',
  'chart.conditionName.periapical_lesion': 'ضایعهٔ اپیکال',
  'chart.conditionName.sealant': 'فیشورسیلانت',
  'chart.conditionName.temporary': 'موقت',
  'chart.conditionName.watch': 'تحت نظر',
  'chart.note.title': 'یادداشت',
  'chart.note.placeholder': 'هر نکتهٔ قابل ثبت دربارهٔ این دندان',
  'chart.materialName.composite': 'کامپوزیت',
  'chart.materialName.amalgam': 'آمالگام',
  'chart.materialName.glass_ionomer': 'گلاس\u200cآینومر',
  'chart.materialName.zirconia': 'زیرکونیا',
  'chart.materialName.pfm': 'فلز-سرامیک (PFM)',
  'chart.materialName.full_metal': 'فول\u200cمتال',
  'chart.materialName.emax': 'ای\u200cمکس',
  'chart.materialName.temporary': 'موقت',
  'chart.materialName.gold': 'طلا',

  // ── hover card ──────────────────────────────────────────────────────────
  'chart.primary': 'شیری',
  'chart.tooltip.notCharted': 'هنوز چیزی برای این دندان ثبت نشده است.',
  'chart.tooltip.sound': 'معاینه شده — بدون یافته',
  'chart.tooltip.lastRecorded': 'آخرین ثبت',
  'chart.quadrant.upperRight': 'بالا راست (بیمار)',
  'chart.quadrant.upperLeft': 'بالا چپ (بیمار)',
  'chart.quadrant.lowerRight': 'پایین راست (بیمار)',
  'chart.quadrant.lowerLeft': 'پایین چپ (بیمار)',
  'chart.toothName.centralIncisor': 'ثنایای میانی (سانترال)',
  'chart.toothName.lateralIncisor': 'ثنایای کناری (لترال)',
  'chart.toothName.canine': 'نیش (کانین)',
  'chart.toothName.firstPremolar': 'پرمولر اول',
  'chart.toothName.secondPremolar': 'پرمولر دوم',
  'chart.toothName.firstMolar': 'مولر اول',
  'chart.toothName.secondMolar': 'مولر دوم',
  'chart.toothName.thirdMolar': 'مولر سوم (عقل)',

  // ── جلسهٔ درمان — میز کار ویزیت (docs/dent-visit.md) ─────────────────────

  'visit.error.title': 'جلسهٔ درمان باز نشد',
  'visit.error.body': 'خواندن این نوبت ممکن نشد. لطفاً دوباره تلاش کنید.',
  'visit.notFound.title': 'جلسه یافت نشد',
  'visit.notFound.description':
    'این نوبت وجود ندارد، برای شما نیست، یا پروندهٔ بیماری به آن متصل نشده است.',
  'visit.unknownPatient': 'بیمار بدون نام',
  'visit.openRecord': 'پروندهٔ بیمار',
  'visit.finish.action': 'پایان جلسه',
  'visit.finish.working': 'در حال بستن…',
  'visit.finish.confirm.title': 'این جلسه بسته شود؟',
  'visit.finish.confirm.body': 'هرچه ذخیره نشده ثبت می‌شود و جلسه بسته می‌شود. پس از آن این جلسه فقط خواندنی است و از این برنامه دوباره باز نمی‌شود.',
  // «نوبت بعدی» — asked only when the visit leaves work planned and not done.
  'visit.finish.followUp.title': '{{count}} اقدام از پلن درمان باقی مانده',
  'visit.finish.followUp.andMore': 'و {{count}} مورد دیگر',
  'visit.finish.followUp.today': 'همین امروز',
  'visit.finish.followUp.tomorrow': 'فردا',
  'visit.finish.followUp.withinWeek': 'کمتر از یک هفته',
  'visit.finish.followUp.within2Weeks': 'کمتر از دو هفته',
  'visit.finish.followUp.withinMonth': 'کمتر از یک ماه',
  'visit.finish.followUp.within3Months': 'کمتر از سه ماه',
  'visit.finish.followUp.when': 'نوبت بعدی تا چه زمانی باشد؟',
  'visit.finish.followUp.none': 'لازم نیست',
  'visit.finish.followUp.deskNote': 'به پذیرش اعلام می‌شود تا نوبت بعدی را با شما هماهنگ کند.',
  'visit.finish.followUp.noneNote': 'چیزی به پذیرش اعلام نمی‌شود.',
  'visit.finish.done.plain': 'جلسه بسته شد.',
  'visit.finish.done.followUpRaised': 'جلسه بسته شد. نوبت بعدی به پذیرش اعلام شد.',
  'visit.finish.done.alreadyBooked': 'جلسه بسته شد. این بیمار از قبل نوبت بعدی دارد.',
  'visit.finish.done.followUpFailed': 'جلسه بسته شد، اما نوبت بعدی به پذیرش اعلام نشد.',
  'visit.finish.error.subjective': 'شرح حال ذخیره نشد، بنابراین جلسه بسته نشد. دوباره تلاش کنید.',
  'visit.finish.error.complete': 'شرح حال ذخیره شد، اما بستن جلسه ممکن نشد. دوباره تلاش کنید.',

  // ── ویزیت تصویری ─────────────────────────────────────────────────────────
  'visit.call.start': 'تماس تصویری',
  'visit.call.title': 'تماس تصویری',
  'visit.call.panelLabel': 'پنجرهٔ تماس تصویری',
  'visit.call.connecting': 'در حال اتصال…',
  // «پایان تماس», never «پایان جلسه» — closing the visit is one-way and closes
  // the record; hanging up does neither, and the two must never read alike.
  'visit.call.hangUp': 'پایان تماس',
  'visit.call.notRecorded': 'این تماس ضبط نمی‌شود و چیزی از آن ذخیره نمی‌گردد.',
  'visit.call.error.connection': 'تماس برقرار نشد. اتصال اینترنت را بررسی کنید و دوباره تلاش کنید.',
  'visit.call.error.unavailable': 'تماس تصویری در این محیط فعال نیست.',
  'visit.call.error.visitOver': 'این جلسه بسته شده است و تماس تصویری روی آن برقرار نمی‌شود.',

  'visit.readOnly.badge': 'فقط خواندنی',
  'visit.readOnly.note':
    'این جلسه بسته شده است و چیز تازه‌ای روی آن ثبت نمی‌شود. آنچه پیش‌تر ثبت شده همچنان نمایش داده می‌شود.',

  'visit.ai.costsCredits': 'این کار از اعتبار هوش مصنوعی کم می‌کند.',

  'visit.tabs.meds': 'دارو',
  'visit.tabs.orders': 'دستورات',
  'visit.tabs.diagnosis': 'تشخیص',
  'visit.tabs.questions': 'پرسش‌ها',
  'visit.tabs.files': 'فایل‌ها',
  'visit.tabs.sectionsLabel': 'بخش‌های جلسه',

  // ── §3.1.1 اودنتوگرام ────────────────────────────────────────────────────
  'visit.chart.title': 'چارت دندان',
  'visit.chart.hint': 'برای دیدن یافته‌ها و اقدام‌های برنامه‌ریزی‌شده، دندان را انتخاب کنید.',
  'visit.chart.tooth': 'دندان {{fdi}}',
  'visit.chart.openTooth': 'یافته‌ها',
  'visit.chart.planForTooth': 'افزودن به طرح درمان',
  'visit.chart.noPlanForTooth': 'برای این دندان اقدامی برنامه‌ریزی نشده است.',
  'visit.chart.history': 'سابقه',
  'visit.chart.noHistory': 'برای این دندان چیزی ثبت نشده است.',
  'visit.chart.historyUnavailable': 'بارگذاری سابقه ممکن نشد.',
  'visit.chart.historical': 'سابق',

  // ── §3.1.2 شرح حال ───────────────────────────────────────────────────────
  'visit.subjective.title': 'شرح حال بیمار',
  'visit.subjective.error.title': 'شرح حال بارگذاری نشد',
  'visit.subjective.error.body': 'خواندن شرح حال این جلسه ممکن نشد. لطفاً دوباره تلاش کنید.',
  'visit.subjective.saved': 'ثبت شد',
  'visit.subjective.saveFailed': 'ثبت شرح حال ممکن نشد. لطفاً دوباره تلاش کنید.',
  'visit.subjective.history': 'سوابق بیمار',
  'visit.subjective.noAllergies': 'حساسیتی ثبت نشده است',
  'visit.subjective.conditions': 'بیماری‌ها',
  'visit.subjective.medications': 'داروها',
  'visit.subjective.chiefComplaint': 'شکایت اصلی',
  'visit.subjective.dictateComplaint': 'گفتن شکایت اصلی با صدا',
  'visit.subjective.dictateNotes': 'گفتن یادداشت با صدا',
  'visit.subjective.teeth': 'دندان‌های درگیر',
  'visit.subjective.noTeeth': 'روی دندان‌های مورد نظر در چارت بزنید',
  'visit.subjective.addTooth': 'افزودن دندان {{fdi}}',
  'visit.subjective.selectToothFirst': 'ابتدا از چارت دندان انتخاب کنید',
  'visit.subjective.painScore': 'شدت درد (۰ تا ۱۰)',
  'visit.subjective.painCharacter': 'نوع درد',
  'visit.subjective.pain.sharp': 'تیز',
  'visit.subjective.pain.dull': 'مبهم',
  'visit.subjective.pain.throbbing': 'ضربان‌دار',
  'visit.subjective.pain.sensitivity': 'حساسیت',
  'visit.subjective.pain.none': 'بدون درد',
  'visit.subjective.onset': 'زمان شروع',
  'visit.subjective.duration': 'مدت',
  'visit.subjective.aggravating': 'تشدیدکننده',
  'visit.subjective.relieving': 'تسکین‌دهنده',
  'visit.subjective.dentalHistory': 'سابقهٔ دندانی',
  'visit.subjective.notes': 'یادداشت',
  'visit.subjective.priorVisits': 'مراجعات قبلی',
  'visit.subjective.noPriorVisits': 'مراجعهٔ قبلی ثبت نشده است.',
  'visit.subjective.priorNoSummary': 'شکایتی ثبت نشده',
  'visit.subjective.priorDiagnoses': '{{count}} تشخیص',

  // ── §3.1.3 اقدام درمانی و پلن درمان دندانی ───────────────────────────────
  'visit.plan.title': 'پلن درمان',
  'visit.plan.error.title': 'طرح درمان بارگذاری نشد',
  'visit.plan.error.body': 'خواندن طرح درمان این بیمار ممکن نشد. لطفاً دوباره تلاش کنید.',
  // Clinic-currency refusals, by extensions.code (CLINIC_CURRENCY_UNAVAILABLE,
  // CURRENCY_MISMATCH). Never an exchange rate: two currencies are not combined.
  'visit.plan.error.currencyUnavailable': 'واحد پول مطب خوانده نشد و بدون آن مبالغ طرح درمان نمایش داده نمی‌شود. لطفاً دوباره تلاش کنید.',
  'visit.plan.error.currencyMismatch': 'این مبالغ به واحد پول مطب نیستند و مبالغ با واحدهای پول متفاوت هرگز با هم جمع نمی‌شوند. از مدیر مطب بخواهید واحد پول مطب را بررسی کند.',
  'visit.plan.saveFailed': 'ثبت طرح درمان ممکن نشد.',
  'visit.plan.empty.title': 'هنوز طرح درمانی ثبت نشده',
  'visit.plan.empty.description': 'اقدام‌هایی را که قصد انجامشان را دارید، دندان‌به‌دندان اضافه کنید.',
  'visit.plan.add': 'افزودن اقدام',
  // Confirmation after a line actually lands in the plan — «افزودن به طرح
  // درمان» on the chart only OPENS the form, so the dentist needs to be told
  // when the add itself happened, not when the form opened.
  'visit.plan.added': '«{{what}}» به طرح درمان افزوده شد.',
  'visit.plan.addedForTooth': '«{{what}}» برای دندان {{fdi}} به طرح درمان افزوده شد.',
  // Shown on the chart the moment the button is pressed — it names what the
  // press did, which is open a form, not add a treatment.
  'visit.chart.planFormOpened': 'فرم افزودن برای دندان {{fdi}} باز شد — اقدام را انتخاب کنید.',
  'visit.plan.addItem': 'افزودن به طرح',
  'visit.plan.service': 'اقدام درمانی',
  'visit.plan.choose': 'یک اقدام انتخاب کنید…',
  'visit.plan.tooth': 'دندان',
  'visit.plan.wholeMouth': 'کل دهان',
  'visit.plan.wholeMouthShort': 'دهان',
  'visit.plan.phase': 'فاز',
  'visit.plan.description': 'شرح',
  'visit.plan.untitledItem': 'اقدام بدون عنوان',
  'visit.plan.changeStatus': 'تغییر وضعیت {{item}}',
  'visit.plan.remove': 'حذف {{item}}',
  'visit.plan.showOnChart': 'نمایش روی چارت',
  'visit.plan.surfaces': 'سطوح',
  'visit.plan.sessions': 'تعداد جلسات',
  'visit.plan.sessionsOf': 'جلسهٔ {{done}} از {{total}}',
  // Key kept from when every amount was toman. `{{unit}}` is «تومان» for IRR
  // (common.units.toman), and the ISO code — «AED» — for any other currency.
  'visit.plan.toman': '{{amount}} {{unit}}',
  'visit.plan.noTariff': 'بدون تعرفه',
  'visit.plan.outstanding': 'مانده از پلن: {{amount}}',
  // A service the clinic prices in another currency than the plan's. It is
  // never converted, so it is never priced into this plan. `{{currency}}` and
  // `{{planCurrency}}` are ISO codes («IRR», «AED»): a name would put «تومان»
  // on a plan counted in dirhams.
  'visit.plan.otherCurrency': 'تعرفه به واحد پول دیگر ({{currency}})',
  'visit.plan.otherCurrencyRefused': 'تعرفهٔ «{{name}}» به {{currency}} است و به طرح درمانی به {{planCurrency}} افزوده نمی‌شود.',

  // «ثبت انجام» — what was actually DONE, as against what was quoted.
  'visit.record.openVisit': 'مشاهدهٔ ویزیت',
  'visit.record.open': 'ثبت انجام',
  'visit.record.openSession': 'ثبت جلسه',
  'visit.record.title': 'ثبت انجام — {{treatment}}',
  'visit.record.subtitle': 'آنچه در این ویزیت انجام شد ثبت می‌شود؛ این ثبت، پروندهٔ بالینی است.',
  'visit.record.service': 'خدمت انجام‌شده',
  'visit.record.tooth': 'دندان',
  'visit.record.surfaces': 'سطوح',
  'visit.record.material': 'ماده',
  'visit.record.noMaterial': 'بدون ماده',
  'visit.record.note': 'شرح کار',
  'visit.record.notePlaceholder': 'آنچه انجام شد، به‌اختصار',
  'visit.record.outcome': 'نتیجه',
  'visit.record.outcome.completed': 'تکمیل شد',
  'visit.record.outcome.inProgress': 'ادامه در جلسهٔ بعد',
  'visit.record.chartEffect': 'وضعیت دندان پس از درمان',
  'visit.record.chartEffect.none': 'تغییری در چارت ندهد',
  'visit.record.chartEffect.noneDetail': 'چیزی در چارت دندان ثبت نمی‌شود.',
  'visit.record.chartEffect.detail': 'دندان {{tooth}} در چارت «{{state}}» ثبت می‌شود.',
  'visit.record.chartEffect.detailSurfaces': 'سطوح {{surfaces}} دندان {{tooth}} در چارت «{{state}}» ثبت می‌شود.',
  'visit.record.chartEffect.needsSurfaces': 'برای ثبت وضعیت سطح، ابتدا سطح درمان‌شده را انتخاب کنید؛ در غیر این صورت چیزی در چارت ثبت نمی‌شود.',
  'visit.record.chartEffect.surfaceOption': 'سطوح — {{state}}',
  'visit.record.chartEffect.inProgress': 'این جلسه درمان را تمام نمی‌کند، پس به‌صورت پیش‌فرض چیزی در چارت ثبت نمی‌شود.',
  'visit.record.billingNote':
    'صورت‌حساب و کسر از انبار پس از این ثبت و جدا از آن انجام می‌شوند؛ این فرم مبلغی ثبت نمی‌کند.',
  'visit.record.save': 'ثبت',
  'visit.record.saved': '«{{what}}» ثبت شد.',
  'visit.record.failed': 'ثبت درمان ممکن نشد.',
  'visit.record.doneHere': 'انجام‌شده در این ویزیت ({{count}})',
  'visit.record.void': 'ابطال',
  'visit.record.voidReason': 'دلیل ابطال',
  'visit.record.voidedFor': 'ابطال‌شده — {{reason}}',
  'visit.record.voidConfirm.title': 'ابطال «{{what}}»؟',
  'visit.record.voidConfirm.body':
    'ردیف حذف نمی‌شود؛ با خط‌خوردگی و دلیلی که می‌نویسید در پرونده می‌ماند. دلیل الزامی است.',
  'visit.record.notBilled': 'به صورت‌حساب اضافه نشد',
  'visit.record.voidConfirm.alsoChart': 'وضعیت دندان {{tooth}} در چارت هم باطل شود',
  'visit.record.voidConfirm.stillBilled':
    'هزینهٔ این درمان روی صورت‌حساب بیمار ثبت شده است. با ابطال، هزینه خودکار از صورت‌حساب برمی‌گردد؛ اگر فاکتور صادر شده باشد یک قلم اصلاحی منفی ثبت می‌شود.',
  'visit.record.voidCharge.notReversed':
    'درمان ابطال شد، اما هزینهٔ آن از صورت‌حساب برنگشت. برای اصلاح آن با صندوق هماهنگ کنید.',
  'visit.record.billed': 'روی صورت‌حساب این ویزیت ثبت شد.',

  'visit.plan.noServices.title': 'این مطب هنوز خدمتی تعریف نکرده است',
  'visit.plan.noServices.body':
    'ردیف‌های پلن درمان از خدمات مطب می‌آیند. خدمات دندان‌پزشکی را در پنل کلینیک تعریف و تعرفه‌گذاری کنید.',
  'visit.plan.noServices.action': 'تعریف خدمات در پنل کلینیک',
  'visit.plan.catalogUnavailable':
    'فهرست خدمات مطب خوانده نشد. این به معنای نبود خدمت نیست — دوباره تلاش کنید.',
  'visit.plan.applicability.unset': 'مشخص نشده',
  'visit.plan.applicability.tooth': 'یک دندان',
  'visit.plan.applicability.surfaces': 'سطوح یک دندان',
  'visit.plan.applicability.quadrant': 'یک ناحیه (کوادرانت)',
  'visit.plan.applicability.arch': 'یک فک',
  'visit.plan.applicability.mouth': 'کل دهان',
  'visit.plan.newService.title': 'خدمت جدید',
  'visit.plan.newService.subtitle':
    'به خدمات مطب افزوده می‌شود و برای همهٔ همکاران نیز قابل انتخاب خواهد بود.',
  'visit.plan.newService.name': 'نام خدمت',
  'visit.plan.newService.category': 'گروه',
  'visit.plan.newService.chartEffect': 'اثر روی چارت',
  'visit.plan.newService.applicability': 'کاربرد',
  'visit.plan.newService.tariff': 'تعرفهٔ هر جلسه ({{unit}})',
  'visit.plan.newService.duration': 'مدت هر جلسه (دقیقه)',
  'visit.plan.newService.tariffHint':
    'تعرفه را می‌توان خالی گذاشت؛ خدمت «بدون تعرفه» ثبت می‌شود و تا تعیین تعرفه در صورت‌حساب نمی‌آید.',
  'visit.plan.newService.clinicOnly.title': 'در پنل کلینیک تکمیل می‌شود',
  'visit.plan.newService.clinicOnly.body':
    'مواد مصرفی، سایر هزینه‌ها، پورسانت و بیمه.',
  'visit.plan.newService.save': 'ذخیره و انتخاب',
  'visit.plan.newService.created': '«{{name}}» به خدمات مطب افزوده شد.',
  'visit.plan.newService.nameRequired': 'نام خدمت لازم است.',
  'visit.plan.newService.failed': 'ثبت خدمت ممکن نشد.',
  'visit.plan.newService.badTariff': 'تعرفه باید یک عدد به {{unit}} باشد.',
  'visit.plan.newService.currencyUnknown': 'واحد پول این مطب خوانده نشد، پس تعرفه را اینجا نمی‌توان وارد کرد. خدمت «بدون تعرفه» ثبت می‌شود؛ تعرفه را در پنل کلینیک تعیین کنید.',
  'visit.plan.noClinic':
    'این ویزیت به مطبی نسبت داده نشده است؛ بدون مطب، خدمات و تعرفه‌ها خوانده نمی‌شود.',
  'common.form.optional': '(اختیاری)',
  'visit.plan.locked': 'امضا شده',
  'visit.plan.startNew': 'شروع دورهٔ جدید',
  'visit.plan.lockedNextStep': 'افزودن اقدام تازه، یک دورهٔ درمان جدید آغاز می‌کند.',
  'visit.plan.lockedNote':
    'این طرح درمان تأیید و امضا شده است، پس ردیف‌های آن دیگر تغییر نمی‌کند. وضعیت انجام اقدام‌ها همچنان قابل ثبت است.',
  'visit.plan.phases.emergency': 'اورژانسی',
  'visit.plan.phases.phase1': 'فاز ۱',
  'visit.plan.phases.phase2': 'فاز ۲',
  'visit.plan.phases.maintenance': 'نگهدارنده',
  'visit.plan.status.proposed': 'پیشنهادشده',
  'visit.plan.status.accepted': 'پذیرفته‌شده',
  'visit.plan.status.done': 'انجام‌شده',
  'visit.plan.status.rejected': 'رد شده',
  'visit.plan.status.deferred': 'به تعویق افتاده',
  'visit.plan.planStatus.draft': 'پیش‌نویس',
  'visit.plan.planStatus.proposed': 'ارائه‌شده',
  'visit.plan.planStatus.approved': 'تأییدشده',
  'visit.plan.planStatus.in_progress': 'در حال انجام',
  'visit.plan.planStatus.completed': 'تکمیل‌شده',
  'visit.plan.planStatus.abandoned': 'رهاشده',

  // ── §3.2.1 دارو ──────────────────────────────────────────────────────────
  'visit.meds.empty.title': 'هنوز دارویی تجویز نشده',
  'visit.meds.empty.description': 'برای افزودن دارو به این جلسه، از جستجوی بالا استفاده کنید.',
  'visit.meds.thisVisit': 'تجویزشده در این جلسه',
  'visit.meds.current': 'داروهای فعلی بیمار',
  'visit.meds.suggest': 'پیشنهاد هوش مصنوعی',
  'visit.meds.suggesting': 'در حال تحلیل…',
  'visit.meds.suggestions': 'داروهای پیشنهادی',
  'visit.meds.suggestClose': 'بستن پیشنهادها',
  'visit.meds.suggestAdd': 'افزودن به نسخه',
  'visit.meds.suggestAdded': 'افزوده شد',
  'visit.meds.noSuggestions':
    'پیشنهادی نیست. ابتدا تشخیص یا ارزیابی این جلسه را ثبت کنید — تحلیل بر پایهٔ آنچه برای این جلسه نوشته شده انجام می‌شود.',
  'visit.meds.suggestUnavailable': 'پیشنهاد هوش مصنوعی در دسترس نیست.',
  'visit.meds.followUp': 'پیگیری:',

  // ── §3.2.2 دستورات — فقط لابراتوار و تصویربرداری دندانی ──────────────────
  'visit.orders.error.title': 'دستورات بارگذاری نشد',
  'visit.orders.error.body': 'خواندن دستورات این جلسه ممکن نشد. لطفاً دوباره تلاش کنید.',
  'visit.orders.saveFailed': 'ثبت دستور ممکن نشد.',
  'visit.orders.empty.title': 'دستوری در این جلسه ثبت نشده',
  'visit.orders.empty.description': 'درخواست رادیوگرافی بدهید یا کیس را به لابراتوار بفرستید.',
  'visit.orders.type': 'نوع دستور',
  'visit.orders.types.imaging': 'تصویربرداری',
  'visit.orders.types.lab': 'لابراتوار',
  'visit.orders.types.dental_lab': 'لابراتوار دندانی',
  'visit.orders.service': 'خدمت',
  'visit.orders.serviceScope': 'فقط خدمات «{{type}}»',
  'visit.orders.choose': 'یک خدمت انتخاب کنید…',
  'visit.orders.description': 'شرح',
  'visit.orders.descriptionHint': 'خالی بگذارید تا نام خدمت ثبت شود',
  'visit.orders.notes': 'توضیح برای لابراتوار / رادیولوژی',
  'visit.orders.urgency': 'فوریت',
  'visit.orders.urgencies.routine': 'عادی',
  'visit.orders.urgencies.urgent': 'فوری',
  'visit.orders.urgencies.stat': 'آنی',
  'visit.orders.sessions': 'تعداد جلسات',
  'visit.orders.sessionCount': '{{count}} جلسه',
  'visit.orders.add': 'ثبت دستور',
  'visit.orders.statuses.pending': 'در انتظار',
  'visit.orders.statuses.in_progress': 'در حال انجام',
  'visit.orders.statuses.completed': 'انجام شده',
  'visit.orders.statuses.cancelled': 'لغو شده',
  'visit.orders.transitions.start': 'شروع',
  'visit.orders.transitions.complete': 'ثبت انجام',
  'visit.orders.transitions.cancel': 'لغو',
  'visit.orders.suggest': 'پیشنهاد هوش مصنوعی',
  'visit.orders.suggesting': 'در حال تحلیل…',
  'visit.orders.suggestions': 'دستورهای پیشنهادی',
  'visit.orders.suggestClose': 'بستن پیشنهادها',
  'visit.orders.suggestAdd': 'ثبت دستور',
  'visit.orders.suggestAdded': 'ثبت شده',
  'visit.orders.noSuggestions':
    'پیشنهادی نیست. ابتدا تشخیص یا ارزیابی این جلسه را ثبت کنید — تحلیل بر پایهٔ آنچه برای این جلسه نوشته شده انجام می‌شود.',
  'visit.orders.suggestUnavailable': 'پیشنهاد هوش مصنوعی در دسترس نیست.',
  'visit.orders.suggestDropped': '{{count}} پیشنهاد خارج از فهرست دندانی بود و نمایش داده نشد.',

  // ── §3.2.3 تشخیص، با نمایش مستندات پشتیبان ───────────────────────────────
  'visit.diagnosis.error.title': 'تشخیص‌ها بارگذاری نشد',
  'visit.diagnosis.error.body': 'خواندن تشخیص‌های این جلسه ممکن نشد. لطفاً دوباره تلاش کنید.',
  'visit.diagnosis.saveFailed': 'ثبت تشخیص ممکن نشد.',
  'visit.diagnosis.empty.title': 'تشخیصی ثبت نشده',
  'visit.diagnosis.empty.description':
    'نتیجه‌گیری خود را ثبت کنید؛ یافته‌هایی که بر پایهٔ آن است همراه تشخیص ذخیره می‌شود.',
  'visit.diagnosis.name': 'تشخیص',
  'visit.diagnosis.code': 'کد ICD',
  'visit.diagnosis.certainty': 'قطعیت',
  'visit.diagnosis.verification.provisional': 'موقت',
  'visit.diagnosis.verification.confirmed': 'قطعی',
  'visit.diagnosis.add': 'ثبت تشخیص',
  'visit.diagnosis.remove': 'حذف {{name}}',
  'visit.diagnosis.willAttach': '{{count}} مستند پشتیبان همراه این تشخیص ذخیره می‌شود.',
  'visit.diagnosis.evidence': 'مستندات ({{count}})',
  'visit.diagnosis.noEvidence': 'مستندی همراه این تشخیص ثبت نشده است.',
  'visit.diagnosis.evidenceKind.subjective': 'شرح حال',
  'visit.diagnosis.evidenceKind.history': 'سوابق',
  'visit.diagnosis.evidenceKind.chart': 'چارت',
  'visit.diagnosis.evidenceKind.file': 'سند',
  'visit.diagnosis.evidenceKind.order': 'دستور',
  'visit.diagnosis.evidenceKind.ai': 'تحلیل هوش مصنوعی',
  'visit.diagnosis.showTooth': 'نمایش دندان',
  'visit.diagnosis.toothEvidence': 'یافته‌های دندان {{fdi}}',
  'visit.diagnosis.aiAssisted': 'به کمک هوش مصنوعی',
  'visit.diagnosis.suggest': 'پیشنهاد هوش مصنوعی',
  'visit.diagnosis.suggesting': 'در حال تحلیل…',
  'visit.diagnosis.suggestions': 'تشخیص‌های پیشنهادی',
  'visit.diagnosis.noSuggestions':
    'پیشنهادی نیست. ابتدا شرح حال را ثبت کنید — تحلیل بر پایهٔ آنچه برای این جلسه نوشته شده انجام می‌شود.',
  'visit.diagnosis.suggestUnavailable': 'پیشنهاد هوش مصنوعی در دسترس نیست.',
  'visit.diagnosis.accept': 'ثبت',
  'visit.diagnosis.alreadyRecorded': 'ثبت شده',
  'visit.diagnosis.confidence.high': 'اطمینان بالا',
  'visit.diagnosis.confidence.medium': 'اطمینان متوسط',
  'visit.diagnosis.confidence.low': 'اطمینان پایین',

  // ── دستیار شرح حال (SOAP) — تب تشخیص ─────────────────────────────────────
  'visit.soap.title': 'دستیار شرح حال',
  // «با پایان ضبط» و نه «سپس دکمه را بزنید»: دیگر دکمهٔ جداگانه‌ای نیست —
  // خودِ توقف ضبط، تحلیل را می‌فرستد و برچسب دکمهٔ توقف همین را می‌گوید.
  'visit.soap.description':
    'آنچه در جلسه گذشت را بگویید؛ با پایان ضبط، دستیار بخش‌های شرح حال را تکمیل می‌کند و بر اساس مشکل، توصیه می‌دهد. تا شما تأیید نکنید چیزی ثبت نمی‌شود.',
  'visit.soap.speak': 'اعلام شرح حال',
  'visit.soap.speakStop': 'پایان و دریافت توصیه',
  'visit.soap.analyzing': 'در حال تحلیل…',
  'visit.soap.heard': 'متن شنیده‌شده:',
  'visit.soap.retry': 'ارسال دوباره',
  'visit.soap.voiceUnavailable':
    'اعلام شرح حال به میکروفون و اتصال امن (HTTPS) نیاز دارد و در این مرورگر در دسترس نیست.',
  'visit.soap.draftTitle': 'پیش‌نویس پیشنهادی شرح حال',
  'visit.soap.sections.s': 'شرح حال (S) — افزوده به یادداشت',
  'visit.soap.sections.o': 'معاینه و یافته‌ها (O)',
  'visit.soap.sections.a': 'ارزیابی (A)',
  'visit.soap.sections.p': 'برنامه درمان (P)',
  'visit.soap.apply': 'اعمال در شرح حال بیمار',
  'visit.soap.applied': 'در شرح حال بیمار ثبت شد.',
  'visit.soap.applyFailed': 'اعمال پیش‌نویس ممکن نشد.',
  'visit.soap.dismiss': 'رد کردن',
  'visit.soap.noNews': 'نکتهٔ تازه‌ای برای افزودن به شرح حال پیدا نشد.',
  'visit.soap.refineUnavailable': 'تکمیل شرح حال در دسترس نیست.',
  'visit.soap.adviceTitle': 'توصیهٔ دستیار',
  'visit.soap.adviceUnavailable': 'توصیهٔ هوش مصنوعی در دسترس نیست.',
  'visit.soap.suggestedDiagnosis': 'تشخیص پیشنهادی',
  'visit.soap.recordDiagnosis': 'ثبت به عنوان تشخیص',
  'visit.soap.accepted': 'این تشخیص پذیرفته و در فهرست تشخیص‌های این جلسه ثبت شد.',
  'visit.soap.actions': 'اقدامات پیشنهادی',
  'visit.soap.medications': 'داروهای پیشنهادی',
  'visit.soap.aiEvidence': 'برآمده از تحلیل متن جلسه',

  // ── یافته‌های دندانی متن جلسه → چارت دندان ────────────────────────────────
  'visit.soap.teeth.title': 'یافته‌های دندان‌ها',
  'visit.soap.teeth.description':
    'این موارد از متن جلسه دربارهٔ دندان‌های مشخص خوانده شده است. هر کدام را که تأیید کنید در چارت دندان ثبت می‌شود؛ بقیه ثبت نمی‌شوند.',
  'visit.soap.teeth.lowConfidenceHint':
    'موارد کم‌اطمینان از پیش تیک نخورده‌اند — شمارهٔ دندان را پیش از ثبت بررسی کنید.',
  'visit.soap.teeth.tooth': 'دندان {{fdi}}',
  'visit.soap.teeth.surface': 'سطح {{surface}}',
  'visit.soap.teeth.historical': 'سابقه',
  'visit.soap.teeth.record': 'ثبت در چارت دندان ({{count}})',
  'visit.soap.teeth.recording': 'در حال ثبت…',
  'visit.soap.teeth.recorded': 'در چارت دندان ثبت شد.',
  'visit.soap.teeth.recordFailed': 'ثبت در چارت دندان ممکن نشد.',
  'visit.soap.teeth.none': 'یافتهٔ دندانی مشخصی در متن جلسه پیدا نشد.',
  'visit.soap.teeth.unavailable': 'خواندن یافته‌های دندان در دسترس نیست.',
  'visit.soap.teeth.confidence.high': 'اطمینان بالا',
  'visit.soap.teeth.confidence.medium': 'اطمینان متوسط',
  'visit.soap.teeth.confidence.low': 'اطمینان پایین',

  // The chart's own vocabulary, in the dentist's language. Keys are the values
  // the dental service defines; an unknown one falls back to the raw value
  // rather than showing an empty row.
  'tooth.aspect.presence': 'وجود دندان',
  'tooth.aspect.condition': 'وضعیت دندان',
  'tooth.aspect.surface': 'وضعیت سطح',
  'tooth.value.sound': 'سالم',
  'tooth.value.caries': 'پوسیدگی',
  'tooth.value.root_canal': 'عصب‌کشی',
  'tooth.value.post_core': 'پست و کور',
  'tooth.value.crown': 'روکش',
  'tooth.value.veneer': 'ونیر',
  'tooth.value.implant': 'ایمپلنت',
  'tooth.value.bridge_abutment': 'پایهٔ بریج',
  'tooth.value.bridge_pontic': 'پونتیک',
  'tooth.value.fracture': 'شکستگی',
  'tooth.value.attrition': 'سایش',
  'tooth.value.mobility': 'لقی',
  'tooth.value.periapical_lesion': 'ضایعهٔ اپیکال',
  'tooth.value.sealant': 'فیشورسیلانت',
  'tooth.value.temporary': 'موقت',
  'tooth.value.watch': 'تحت نظر',
  'tooth.value.restoration': 'ترمیم',
  'tooth.value.recurrent_caries': 'پوسیدگی ثانویه',
  'tooth.value.fractured': 'شکسته',
  'tooth.value.present': 'موجود',
  'tooth.value.extracted': 'کشیده‌شده',
  'tooth.value.exfoliated': 'افتاده (شیری)',
  'tooth.value.congenitally_absent': 'مادرزادی غایب',
  'tooth.value.unerupted': 'نروییده',
  'tooth.value.impacted': 'نهفته',
  'tooth.material.composite': 'کامپوزیت',
  'tooth.material.amalgam': 'آمالگام',
  'tooth.material.glass_ionomer': 'گلاس‌آینومر',
  'tooth.material.zirconia': 'زیرکونیا',
  'tooth.material.pfm': 'فلز-سرامیک',
  'tooth.material.full_metal': 'فول متال',
  'tooth.material.emax': 'ای‌مکس',
  'tooth.material.temporary': 'موقت',
  'tooth.material.gold': 'طلا',

  // ── §3.2.4 پرسش‌ها — دستیار بالینی ───────────────────────────────────────
  'visit.questions.title': 'دستیار بالینی',
  'visit.questions.forDiagnoses': 'پرسش‌هایی که این تشخیص‌ها را تأیید یا رد می‌کند: {{list}}',
  'visit.questions.noDiagnosesYet':
    'هنوز تشخیصی ثبت نشده — دستیار بر پایهٔ شکایتی که نوشته‌اید پرسش می‌سازد.',
  'visit.questions.generate': 'یافتن نکات مبهم',
  'visit.questions.generating': 'در حال بررسی…',
  'visit.questions.unavailable': 'دستیار بالینی در دسترس نیست.',
  'visit.questions.fallbackNote':
    'این پرسش‌ها عمومی هستند و برای این بیمار نوشته نشده‌اند.',
  'visit.questions.empty.title': 'پرسش بازی نیست',
  'visit.questions.empty.description': 'برای پشتیبانی از تشخیص‌های فعلی، اطلاعات بیشتری لازم نیست.',
  'visit.questions.count': '{{count}} پرسش',
  'visit.questions.yes': 'بله',
  'visit.questions.no': 'خیر',
  'visit.questions.recorded': 'ثبت شد: {{statement}}',
  'visit.questions.recordFailed': 'ثبت پاسخ در شرح حال ممکن نشد.',
  'visit.questions.askTitle': 'پرسش از دستیار',
  'visit.questions.askPlaceholder': 'دربارهٔ این بیمار بپرسید…',
  'visit.questions.ask': 'بپرس',
  'visit.questions.asking': 'در حال پرسیدن…',
  'visit.questions.followUps': 'پیگیری',

  // ── §3.2.5 فایل‌ها و گزارش استخراج‌شدهٔ هرکدام ────────────────────────────
  // ── فایل‌ها: what kind of thing is being uploaded ────────────────────────
  'visit.files.kind': 'این فایل چیست؟',
  'visit.files.kinds.image': 'تصویر دندانی',
  'visit.files.kinds.document': 'سند',
  'visit.files.viewType': 'نوع تصویر',
  'visit.files.viewTypes.periapical': 'پری‌اپیکال (PA)',
  'visit.files.viewTypes.bitewing': 'بایت‌وینگ (BW)',
  'visit.files.viewTypes.panoramic': 'پانورامیک (OPG)',
  'visit.files.viewTypes.ceph': 'سفالومتری',
  'visit.files.viewTypes.photo': 'عکس',
  'visit.files.plainUploadNote': 'بارگذاری فقط فایل را ذخیره می‌کند. استخراج متن و خواندن تصویر جداگانه انجام می‌شوند.',
  'visit.files.unsupportedImage': 'این قالب تصویر قابل نمایش نیست. از JPEG یا PNG استفاده کنید.',
  'visit.files.openImage': 'باز کردن تصویر',
  'visit.files.extract': 'استخراج متن',
  'visit.files.extracting': 'در حال استخراج…',

  // ── The image workspace ─────────────────────────────────────────────────
  'visit.image.back': 'بازگشت به فایل‌ها',
  'visit.image.tools': 'ابزار ترسیم',
  'visit.image.tool.cursor': 'انتخاب',
  'visit.image.tool.pin': 'نشانه',
  'visit.image.tool.box': 'کادر',
  'visit.image.tool.ellipse': 'دایره',
  'visit.image.tool.arrow': 'فلش',
  'visit.image.tool.freehand': 'قلم آزاد',
  'visit.image.color': 'رنگ قلم',
  'visit.image.colorName.E11D48': 'قرمز',
  'visit.image.colorName.F59E0B': 'کهربایی',
  'visit.image.colorName.0EA5A0': 'فیروزه‌ای',
  'visit.image.colorName.2563EB': 'آبی',
  'visit.image.zoomIn': 'بزرگ‌نمایی',
  'visit.image.zoomOut': 'کوچک‌نمایی',
  'visit.image.fit': 'بازنشانی نما',
  'visit.image.brightness': 'روشنایی',
  'visit.image.contrast': 'کنتراست',
  'visit.image.read': 'خواندن تصویر',
  'visit.image.reading': 'در حال خواندن…',
  'visit.image.readStatus.no_findings': 'دستیار در این تصویر یافتهٔ قابل گزارشی پیدا نکرد. اعتباری کم نشد.',
  'visit.image.readStatus.no_image': 'خواندن تصویر ممکن نشد.',
  'visit.image.comment': 'یادداشت این نشانه',
  'visit.image.commentPlaceholder': 'اینجا چه دیدید؟',
  'visit.image.removeMark': 'حذف این نشانه',
  'visit.image.tooManyMarks': 'هر تصویر حداکثر {{max}} نشانه می‌پذیرد.',
  'visit.image.saveFailed': 'ذخیرهٔ نشانه‌ها ممکن نشد.',
  'visit.image.unsaved': 'نشانه‌های ذخیره‌نشده — «ذخیره» را بزنید.',
  'visit.image.findings': 'آنچه دستیار خواند',
  'visit.image.findingsNote': 'پیشنهاد است؛ تا تأیید نکنید در چارت ثبت نمی‌شود.',
  'visit.image.confidence.high': 'واضح',
  'visit.image.confidence.medium': 'محتمل',
  'visit.image.confidence.low': 'نامطمئن',
  'visit.image.notLocalized': 'محل مشخص نشد',
  'visit.image.unlocalizedNote': 'محل {{count}} یافته روی تصویر مشخص نشد و فقط فهرست شده‌اند.',
  'visit.image.confirm': 'تأیید',

  'visit.files.openFile': 'باز کردن فایل',
  'visit.image.register': 'ثبت',
  'visit.image.registering': 'در حال ثبت…',
  'visit.image.notRegistered.title': 'به‌عنوان تصویر دندانی ثبت نشده',
  'visit.image.notRegistered.body': 'می‌توانید ببینیدش. برای علامت‌گذاری و خواندن با دستیار، نوع تصویر لازم است — بایت‌وینگ و عکس یک چیز را نشان نمی‌دهند.',
  'visit.image.changeView': 'تغییر نوع',
  'visit.image.viewType.title': 'نوع تصویر',
  'visit.image.viewType.body': 'این تعیین می‌کند دستیار چه چیزی می‌تواند گزارش کند — بایت‌وینگ ضایعهٔ پری‌اپیکال را نشان نمی‌دهد و عکس، استخوان را. اگر اشتباه است اصلاحش کنید.',
  'visit.image.discard.title': 'نشانه‌هایی که کشیده‌اید حذف شود؟',
  'visit.image.discard.body': 'ذخیره نشده‌اند و نسخهٔ دیگری از آن‌ها وجود ندارد.',
  'visit.image.discard.confirm': 'حذف',
  'visit.files.error.title': 'فایل‌ها بارگذاری نشد',
  'visit.files.error.body': 'خواندن اسناد این بیمار ممکن نشد. لطفاً دوباره تلاش کنید.',
  'visit.files.empty.title': 'سندی ثبت نشده',
  'visit.files.empty.description': 'رادیوگرافی، جواب آزمایش یا نامهٔ ارجاع را بارگذاری کنید.',
  'visit.files.upload': 'بارگذاری سند',
  'visit.files.uploading': 'در حال بارگذاری…',
  'visit.files.uploadFailed': 'بارگذاری سند ممکن نشد.',
  'visit.files.readFailed': 'خواندن فایل ممکن نشد.',
  'visit.files.tooLarge': 'حجم فایل بیش از ۱۵ مگابایت است.',
  'visit.files.docType': 'نوع سند',
  'visit.files.docTypes.lab_report': 'جواب آزمایش',
  'visit.files.docTypes.prescription': 'نسخه',
  'visit.files.docTypes.general': 'سایر',
  'visit.files.attachTooth': 'اتصال به دندان {{fdi}}',
  'visit.files.thisVisit': 'این جلسه',
  'visit.files.hasReport': 'گزارش',
  'visit.files.noReport': 'گزارشی از این سند استخراج نشده است.',
  'visit.files.previewFailed': 'بازکردن فایل ممکن نشد.',
  'visit.files.bytesGone': 'فایل اصلی دیگر ذخیره نیست؛ فقط گزارش آن باقی مانده است.',
  'visit.files.remove': 'حذف {{name}}',
  'visit.files.units.b': 'بایت',
  'visit.files.units.kb': 'کیلوبایت',
  'visit.files.units.mb': 'مگابایت',

  // ── credits (اعتبار) ──────────────────────────────────────────────────────
  'credits.title': 'اعتبار پارسینا',
  'credits.subtitle': 'موجودی پارسه، اینکه کجا خرج شده و چطور شارژ کنید.',
  'credits.unit': 'پارسه',
  'credits.toman': 'تومان',
  'credits.tomanShort': 'ت',
  'credits.currentBalance': 'موجودی فعلی',
  'credits.buy': 'خرید پارسه',
  'credits.topUp': 'شارژ',
  'credits.percent': '٪{{value}}',
  'credits.timesUsed': '{{count}} بار',
  'credits.itemCount': '{{count}} مورد',
  'credits.minutesUsed': '{{count}} دقیقه',
  'credits.byService': 'کجا خرج شد',
  'credits.transactions': 'تراکنش‌ها',

  'credits.level.low': 'اعتبار کم',
  'credits.level.lowShort': 'کم',
  'credits.level.mid': 'رو به اتمام',
  'credits.level.midShort': 'متوسط',
  'credits.level.ok': 'اعتبار مناسب',
  'credits.level.okShort': 'خوب',
  'credits.banner.low': 'فقط {{coins}} پارسه مانده است. با تمام‌شدن اعتبار، دستیار متوقف می‌شود.',
  'credits.banner.mid': '{{coins}} پارسه مانده — کافی برای چند جلسهٔ دیگر.',

  'credits.service.assistant': 'دستیار بالینی',
  'credits.service.interaction': 'بررسی تداخل',
  'credits.service.transcription': 'پیاده‌سازی صوت',
  'credits.service.topUp': 'شارژ اعتبار',
  'credits.service.gift': 'کد هدیه',
  'credits.service.sms': 'پیامک',
  'credits.service.ai': 'سرویس هوشمند',

  'credits.filter.label': 'فیلتر تراکنش‌ها',
  'credits.filter.all': 'همه',
  'credits.filter.spend': 'مصرف',
  'credits.filter.topUp': 'افزایش',
  'credits.group.label': 'گروه‌بندی',
  'credits.group.day': 'روز',
  'credits.group.type': 'سرویس',
  'credits.range.label': 'بازهٔ زمانی',
  'credits.range.all': 'همهٔ زمان‌ها',
  'credits.range.days7': '۷ روز اخیر',
  'credits.range.days30': '۳۰ روز اخیر',
  'credits.range.thisMonth': 'این ماه',
  'credits.time.today': 'امروز',
  'credits.time.yesterday': 'دیروز',

  'credits.kpi.month': 'مصرف این ماه',
  'credits.kpi.perVisit': 'هر جلسه',
  'credits.kpi.topService': 'بیشترین مصرف',

  'credits.showingRange': 'نمایش {{from}}–{{to}} از {{total}}',
  'credits.pager.page': 'صفحهٔ {{page}} از {{total}}',
  'credits.pager.previous': 'قبلی',
  'credits.pager.next': 'بعدی',

  'credits.empty.title': 'هنوز تراکنشی ثبت نشده',
  'credits.empty.hint': 'هر عملیات دستیار در جلسهٔ درمان اینجا ثبت می‌شود.',
  'credits.empty.filtered': 'در این بازه چیزی نیست',
  'credits.empty.filteredHint': 'بازهٔ بازتری یا فیلتر دیگری را امتحان کنید.',
  'credits.error.title': 'تراکنش‌ها در دسترس نیست',
  'credits.error.body': 'خواندن اعتبار ممکن نشد. مبلغی کسر نشده است.',

  'credits.priceList.title': 'هر عملیات چند پارسه؟',
  'credits.priceList.hint': 'فقط با فشردن دکمه کسر می‌شود — هیچ چیز خودکار اجرا نمی‌شود.',
  'credits.priceList.viewAll': 'نمایش همه',
  // تنها ردیف دقیقه‌ای فهرست. سرویس به‌سمت بالا گرد می‌کند، پس کوتاه‌ترین
  // گفتن هم یک دقیقهٔ کامل حساب می‌شود.
  'credits.price.transcription': 'گفتن با صدا (تبدیل گفتار به متن)',
  'credits.price.differential': 'پیشنهاد تشخیص هوش مصنوعی',
  'credits.price.advice': 'نکات دستیار بالینی',
  'credits.price.soap': 'تکمیل یادداشت',
  'credits.price.teeth': 'یافته‌های دندان از شرح جلسه',
  'credits.price.confirmq': 'پرسش‌های تکمیلی',
  'credits.price.ask': 'پرسش از دستیار',
  'credits.price.ocr': 'خواندن سند بارگذاری‌شده',
  'credits.price.interaction': 'بررسی تداخل دارویی',

  'credits.topUp.chooseAmount': 'انتخاب مبلغ',
  'credits.topUp.recommended': 'پیشنهادی',
  'credits.topUp.approxVisits': 'حدود {{count}} جلسه با دستیار',
  'credits.topUp.custom': 'مبلغ دلخواه',
  'credits.topUp.customAria': 'مبلغ',
  'credits.topUp.payVia': 'پرداخت {{amount}} تومان با {{gateway}}',
  'credits.topUp.enterAmount': 'مبلغ را وارد کنید',
  'credits.topUp.redirecting': 'در حال انتقال به درگاه…',
  'credits.topUp.redirectNote': 'به درگاه بانکی منتقل می‌شوید و پس از پرداخت به همین صفحه بازمی‌گردید.',
  'credits.topUp.minimum': 'کمترین مبلغ خرید {{amount}} تومان است.',
  'credits.topUp.failed': 'شروع پرداخت ممکن نشد. لطفاً دوباره تلاش کنید.',
  'credits.topUp.failedWithReason': 'شروع پرداخت ممکن نشد: {{reason}}',
  'credits.gateway.saderat': 'بانک صادرات',
  'credits.gateway.zarinpal': 'زرین‌پال',
  'credits.payment.done': 'پرداخت موفق — اعتبار شما شارژ شد.',
  'credits.payment.failed': 'پرداخت انجام نشد. مبلغی کسر نشده است.',

  'credits.gift.title': 'کد هدیه',
  'credits.gift.hint': 'کدی از کمپین‌های پارسینا دارید؟ اینجا وارد کنید تا پارسهٔ آن به اعتبارتان اضافه شود.',
  'credits.gift.placeholder': 'PARSINA-1404-XXXX',
  'credits.gift.submit': 'فعال‌سازی',
  'credits.gift.submitting': 'در حال فعال‌سازی…',
  'credits.gift.empty': 'ابتدا کد را وارد کنید.',
  'credits.gift.notFound': 'این کد معتبر نیست. لطفاً آن را دقیقاً همان‌طور که دریافت کرده‌اید وارد کنید.',
  'credits.gift.oneUse': 'هر کد فقط یک‌بار قابل استفاده است.',
  'credits.gift.success': '{{parseh}} پارسه افزوده شد',
  'credits.gift.successSub': 'حدود {{visits}} جلسه با دستیار.',
  'credits.gift.newBalance': 'موجودی جدید',
  'credits.gift.myCodes': 'کدهای شما',
  'credits.gift.worth': '{{parseh}} پارسه — حدود {{visits}} جلسه',
  'credits.gift.status.issued': 'استفاده‌نشده',
  'credits.gift.status.redeemed': 'استفاده‌شده',
  'credits.gift.status.revoked': 'باطل‌شده',
  'credits.gift.status.expired': 'منقضی‌شده',

  'credits.lowBalance.title': 'هشدار اعتبار کم',
  'credits.lowBalance.hint': 'وقتی موجودی از این مقدار کمتر شود به شما اطلاع می‌دهیم.',
  'credits.lowBalance.toggleAria': 'فعال‌سازی هشدار اعتبار کم',
  'credits.lowBalance.thresholdAria': 'حد هشدار، به پارسه',
  'credits.lowBalance.active': 'زیر {{coins}} پارسه به شما هشدار داده می‌شود.',
  'credits.lowBalance.off': 'هشدارها خاموش است.',
  'credits.lowBalance.invalid': 'حد هشدار معتبر وارد کنید.',
  'credits.lowBalance.saved': 'تنظیمات هشدار ذخیره شد.',
  'credits.lowBalance.failed': 'ذخیرهٔ تنظیمات هشدار ممکن نشد.',
};
